import React from "react";
import NFLookupEmptyForms from "src/components/Shared/NewForms/NFLookupEmptyForms";

function VendorInvoicesDetailSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default VendorInvoicesDetailSkeleton;
